import { size } from '@styles/theme'
import styled from '@emotion/styled'

const BodyText = styled.div`
  // padding-bottom: ${size(1.5)};
  // padding-bottom: ${size(1.15)};
  padding-bottom: ${size(0.75)};

  // padding-top: ${size(0.5)};
  // padding-top: ${size(0.25)};
  padding-top: ${size(0.15)};

  line-height: ${size(2.5)};
  color: rgb(225,225,225);
  white-space: pre-line;
  
  p {
    margin: 0;
    min-height: ${size(2.5)};
  }
  
  a {
    text-decoration: none;
  }
`

const PostBody = ({ handleBodyClick, body }) => {
  return (
    <BodyText
      onClick={handleBodyClick}
      dangerouslySetInnerHTML={{ __html: body || '' }}
    />
  )
}

export { PostBody }
